var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "hex-shape",
    fillRule: "evenodd",
    stroke: "none",
    d: "M 50.015167 -0.00016 L 93.030655 24.825249 L 93.030655 74.476044 L 50.015167 99.320999 L 7.018764 74.476044 L 7.018764 24.825249 L 50.015167 -0.00016 Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "hex-icon",
    transform: "translate(25,25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 42.128906 22.257813 C 42.136719 22.066406 42.144531 21.878906 42.144531 21.695313 C 42.144531 14.445313 36.242188 8.546875 28.992188 8.546875 C 23.984375 8.546875 19.410156 11.441406 17.214844 15.878906 C 16.078125 15.128906 14.75 14.722656 13.355469 14.722656 C 9.652344 14.722656 6.609375 17.609375 6.363281 21.253906 C 2.582031 22.628906 0 26.257813 0 30.332031 C 0 35.660156 4.339844 40 9.671875 40 L 41.097656 40 C 46.007813 40 50 36.007813 50 31.097656 C 50 26.539063 46.554688 22.769531 42.128906 22.257813 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.c5d03af283847ed2800403fb260a6cdc.svg";
export { ForwardRef as ReactComponent };